import { getItemsCount } from '~/utils/helpers'
import Measurements from '~/utils/Measurements'

export default class Points {
	constructor(object) {
		this.mapApi = 'https://map-api.viadelivery.pro'
		this.apiUrl = '/api/v1/points'
		if (object?.order) {
			this._setByOrder(object)
		} else {
			this.dealerId = object?.dealerId
			this.currency = object?.currency || 'USD'
			this.dealer_dimensions_mu = object?.dealer_dimensions_mu
			this.dealer_weight_mu = object?.dealer_weight_mu
			this.language = object?.language || 'en'
		}
	}

	private _setByOrder(object) {
		const dimensionalMU = object.order.dealer_dimensions_mu
		const weightMU = object.order.dealer_weight_mu
		const measurements = new Measurements(dimensionalMU, weightMU)
		const { muLength, muWidth, muHeight, dimensionalMu, muWeight, weightMu } = measurements.getByOrder(object.order)
		this.dealerId = object.order.shipperId || object.dealerId || object.order.dealerId
		this.currency = object.order.currency || 'USD'
		this.dealer_dimensions_mu = dimensionalMU
		this.dealer_weight_mu = weightMU
		this.language = (object.isRu ? 'ru' : 'en')
		this.totalPrice = object.order.in_total || 0
		this.muLength = muLength
		this.muWidth = muWidth
		this.muHeight = muHeight
		this.dimensionalMu = dimensionalMu
		this.muWeight = muWeight
		this.weightMu = weightMu
		this.choosePointType = object.choosePointType
		this.partner = object.partner
		this.packageCode = object.packageCode || object.order?.packageObject?.package_code
		this.itemsCount = getItemsCount(object?.order)
	}
	
	public setData(object): void {
		this.totalPrice = object?.totalPrice || 0
		this.muLength = object?.muLength 
		this.muWidth = object?.muWidth
		this.muHeight = object?.muHeight
		this.muWeight = object?.muWeight
		this.choosePointType = object?.choosePointType
		this.partner = object?.partner
		this.packageCode = object?.packageCode
	}
	
	public getNearestPoints(address, selectedPointId) {
		if (address) {
			return new Promise(async resolve => {
				const origin = this.apiUrl
				const addr_ess = encodeURIComponent(address)
				let url = origin + `?id=${this.dealerId}&address=${addr_ess}`
					url += this._getDimensionUrl()
					url += `&currency=${this.currency}`
					url += `&order_price=${this.totalPrice}`
					url += `&nearby_points_limit=3`
					if (this.packageCode) {
						url += `&package_code=${this.packageCode}`
					}
					if (this.itemsCount) {
						url += `&items_cnt=${this.itemsCount}`
					}
				const requestData = {
					method: "GET",
					mode: 'cors',
				}
				fetch(url, requestData).then(response => {
					return response.json()
				}).then(async json => {
					const newData = await this._onPointsResult(json, address, selectedPointId)
					resolve(newData)
				}).catch(error => {})
			}).catch(error => {})
		}
	}
	
	public getPointByPointId(pointId) {
		return new Promise(async resolve => {
			if (pointId) {
				const origin = this.mapApi + '/point-list'
				let url = origin + `?id=${this.dealerId}`
					url += this._getDimensionUrl()
					url += `&currency=${this.currency}`
					url += `&order_price=${this.totalPrice}`
					url += `&point_id=${pointId}`
					url += `&nearby_points_limit=3`
					if (this.packageCode) {
						url += `&package_code=${this.packageCode}`
					}
					if (this.itemsCount) {
						url += `&items_cnt=${this.itemsCount}`
					}
				const requestData = {
					method: "GET",
					mode: 'cors',
				}
				const request = new Request(url, requestData)
				fetch(request).then(response => {
					return response.json()
				}).then(async json => {
					const newData = await this._onPointsResult([ json ])
					resolve(newData)
				}).catch(error => {})
			} else {
				resolve()
			}
		}).catch(error => {})
	}

	public getChargeableWeightAndPackage() {
		return new Promise(async resolve => {
			const origin = `${process.env.NEXT_PUBLIC_API2_URL}/package/find`
			let url = origin + `?id=${this.dealerId}`
				url += this._getDimensionUrl()
				if (this.packageCode) {
					url += `&package_code=${this.packageCode}`
				}
				if (this.partner) {
					url += `&partner=${this.partner}`
				}
			const requestData = {
				method: "GET"
			}
			const request = new Request(url, requestData)
			fetch(request).then(response => {
				return response.json()
			}).then(json => {
				resolve(json)
			}).catch(error => {})
		}).catch(error => {})
	}
	
	private async _onPointsResult(json, address, selectedPointId) {
		if (typeof json === 'object') {
			let points = json?.points || json || []
			const goodPoints = []
			if (Array.isArray(points)) {
				points.forEach(point => {
					if (point?.status === 'ACTIVE' || !point?.status) {
						goodPoints.push(point)
					}
				})
			}
			points = goodPoints
			let newDataToSend = {
				totalPrice: this.totalPrice,
				muLength: this.muLength,
				muWidth: this.muWidth,
				muHeight: this.muHeight,
				muWeight: this.muWeight,
			}
			if (address) {
				newDataToSend['manuallyEnteredCustomerAddress'] = address
			}
			if (points?.[0]?.id) {
				let isPointSet = false
				const allowedChoosePointTypes = [ 'customerAddressInput' ]
				if (selectedPointId) {
					let selectedPoint = null
					let otherPoints = []
					let hasSelectedPoint = false
					points?.forEach(point => {
						if (point.id === selectedPointId) {
							selectedPoint = point
							hasSelectedPoint = true
						} else {
							otherPoints.push(point)
						}
					})
					if (selectedPointId && !hasSelectedPoint) {
						const result = await this.getPointByPointId(selectedPointId)
						if (result?.points?.[0]) {
							selectedPoint = result.points[0]
						}
					}
					let threePoints = []
					if (selectedPoint) {
						threePoints.push(selectedPoint)
					}
					if (otherPoints?.[0]) {
						threePoints.push(otherPoints?.[0])
					}
					if (otherPoints?.[1]) {
						threePoints.push(otherPoints?.[1])
					}
					if (threePoints.length < 3) {
						if (otherPoints?.[2]) {
							threePoints.push(otherPoints?.[2])
						}
					}
					newDataToSend['points'] = threePoints
					if (selectedPoint) {
						newDataToSend['selectedPointNumber'] = 0
						newDataToSend['selectedPointId'] = selectedPoint.id
						newDataToSend['in_point'] = selectedPoint.id
						newDataToSend['pointDescription'] = selectedPoint.description
						newDataToSend['in_delivery_cost'] = selectedPoint.price
						isPointSet = true
					}
				} else {
					newDataToSend['points'] = [ points?.[0] ]
					if (points?.[1]) {
						newDataToSend['points'].push(points?.[1])
					}
					if (points?.[2]) {
						newDataToSend['points'].push(points?.[2])
					}
				}
				if (!isPointSet) {
					newDataToSend['selectedPointNumber'] = null
					newDataToSend['selectedPointId'] = null
					newDataToSend['in_point'] = points?.[0]?.id
					newDataToSend['pointDescription'] = points?.[0]?.description
					newDataToSend['in_delivery_cost'] = points?.[0]?.price
				}
			} else {
				newDataToSend['points'] = []
				newDataToSend['in_point'] = null
				newDataToSend['pointDescription'] = null
				newDataToSend['in_delivery_cost'] = 0
				newDataToSend['selectedPointNumber'] = null
				newDataToSend['selectedPointId'] = null
			}
			if (json.origin) {
				return this._insertCustomerDecodedAddress(json.origin, newDataToSend)
			} else {
				if (address) {
					return await this._getGeoDecode(address, newDataToSend)
				} else {
					return newDataToSend
				}
			}
		}
	}
	
	private _insertCustomerDecodedAddress(object, newDataToSend): void {
		let customerDecodedAddress = {
			address1: (object?.building || '') + (object?.building ? ' ' : '') + (object?.street || ''),
			address2: '',
			city: object.city || '',
			region: '',
			region_code: object.region,
			zip_code: object.zip_code || '',
			country: object?.country || '',
		}
		newDataToSend['customerDecodedAddress'] = customerDecodedAddress
		return newDataToSend
	}
	
	private _getGeoDecode(address, newDataToSend) {
		return new Promise(async resolve => {
			const url = this.mapApi + '/geo-decode?address=' + encodeURIComponent(address) + '&lang=' + this.language
			const requestData = {
				method: "GET",
				mode: 'cors',
			}
			const request = new Request(url, requestData)
			fetch(request).then(response => {
				return response.json()
			}).then(json => {
				resolve(this._insertCustomerDecodedAddress(json, newDataToSend))
			}).catch(error => {})
		}).catch(error => {})
	}
	
	private _getDimensionUrl(): string {
		let length = Math.round(this.muLength * 1000) / 1000
		let width = Math.round(this.muWidth * 1000) / 1000
		let height = Math.round(this.muHeight * 1000) / 1000
		let weight = Math.round(this.muWeight * 1000) / 1000
		let mu = `&dim_units=${this.dimensionalMu || this.dealer_dimensions_mu}&weight_units=${this.weightMu || this.dealer_weight_mu}`
		let url = ''
			url += `&length=${length}`
			url += `&width=${width}`
			url += `&height=${height}`
			url += `&weight=${weight}`
			url += mu
		return url
	}
}
